import * as yup from 'yup'

const schema = yup.object().shape({
  bannersLimit: yup.number().required(),
  requestsLimit: yup.number().required(),
  automaticScan: yup.boolean(),
})

export default schema
